import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ControlUser } from '../model/controlUser';
import { UserOwnerRel } from '../model/userOwnerRel';
import { Group } from '../model/group';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { AppComponent } from '../app.component';


@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css']
})

export class GroupsComponent implements OnInit {


  @ViewChild('groupslisttable', { static: true }) table;
  @ViewChild('groupslistloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;

  @Input() hideHeader: boolean;

  @Output() selected = new EventEmitter<Group>();
  selectedUser: ControlUser;
  selectedRow: number;

  ownerUid: string;

  groupslist: Group[];
  dataSource: MatTableDataSource<Group>;

  // Uso un'unico check sia per Service che per Alias senza permessi
  canUserEdit: boolean = false;

  displayedColumns: string[] = ['name', 'description', 'modifyGroup'];

  backgroundImage: string = "";
  showBackGroundImage: string[] = ["questura@pilomat.com", "questura1@pilomat.com", "gestore@1control.it", "gestore@pilomat.com"];

  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute
  ) {


  }

  ngOnInit(): void {
  }


  async ngAfterViewInit() {

    this.canUserEdit = await this.canUserEditCheck();


    if (this.isService()) {
      this.ownerUid = this.route.snapshot.paramMap.get('uid');
      if (!this.ownerUid) {
        Log.debug('no ownerUid in url ');
        this.ownerUid = this.userService.meUser.uid;
      }
    } else {
      this.ownerUid = this.userService.meUser.uid;
    }

    this.getUserEmail();
    this.getGroups();
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  async canUserEditCheck() {

    const isAlias = await this.appComponent.isAlias();

    if (isAlias) {
      // se è Alias verifico se può modificare
      return await this.checkAliasPermissions("UserEdit");
    } else {
      //se non è Alias verifico se è Service
      if (this.appComponent.isService()) {
        return false;
      } else {
        // se non è né Alias né Service allora può modificare
        return true
      }
    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }


  isService(): boolean {
    return this.appComponent.isService();
  }

  onKey(event: any) {

    let filterString = event.target.value;

    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }

  filterTable(data: Group, filter: string): boolean {

    if (data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  getGroups() {

    Log.debug("getGroups");

    this.loader.showLoading();

    const obs = this.userService.getOwnerGroups(this.ownerUid);
    obs.subscribe(data => {

      this.groupslist = data;

      const ds = new MatTableDataSource(this.groupslist);
      ds.sortingDataAccessor = (item, property) => {
        if (property === 'date') {
          return item && (item as any).createdAt ? (item as any).createdAt.getTime() : 0;
        }
        const value = item ? (item as any)[property] : null;
        if (value == null) {
          return '';
        }
        if (typeof value === 'string') {
          return value.toLowerCase();
        }
        if (typeof value === 'object' && (value as any).displayName) {
          return (value as any).displayName.toLowerCase();
        }
        return value;
      };

      ds.filterPredicate = this.filterTable;
      ds.sort = this.sort;

      this.table.dataSource = ds;

      setTimeout(() => {
        this.loader.hideLoading();
      }, 250);

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }

  addGroup() {

    Log.debug('clicked addgroup ');

    this.router.navigate(['add-group']);
  }

  onRowClicked(row) {

    Log.debug('clicked user with id ' + row.groupId);


    if (this.isService()) {
      this.router.navigate(['add-group/', { uid: row.groupId, ownerUid: this.ownerUid }]);
    } else {
      this.router.navigate(['add-group/' + row.groupId]);
    }

    this.cdRef.detectChanges();
  }

  getUserEmail() {
    this.userService.getFirebaseUserObs().subscribe(firebaseUser => {
      this.userService.getMe().subscribe(user => {
        if (this.showBackGroundImage.includes(user.email)) {
          this.backgroundImage = "url('assets/img/Banner_pconnect_Milano_day.jpg')";
        } else {
          this.backgroundImage = "unset"
        }
      }, errorRes => {
        Log.debug("error cannot retrieve user ");
      });
    }, errorRes => {
      Log.debug("error cannot retrieve user ");
    });
  }

}

